
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Das kann Hunderterlei sein: Eine verpasste Mahlzeit oder eine Abmagerungsdiät,
heiss duschen, ein intensiver Geruch, starke Gefühle, Gewürze oder bestimmte
Nahrungsmittel, Alkohol, langes Schlafen, Ferienbeginn oder -ende, Erschöpfung
oder auch Medikamente. Der springende Punkt ist, dass es den Aktivierungszustand
von Nerven verändert.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;